import styled from 'styled-components';
import { Typography } from 'antd';

const { Text } = Typography;

interface TextProps {
  color?: string;
  transform?: string;
  height?: string;
  top?: string;
  bottom?: string;
  weight?: string;
  cursor?: string;
  size?: string;
  display?: string;
  margin?: string;
  lh?: string;
  decoration?: string;
  width?: string;
}

const AppText = styled(Text)<TextProps>`
  color: ${(props) => props.color};
  text-transform: ${(props) => props.transform};
  height: ${(props) => props.height};
  margin: ${(props) => props.margin};
  margin-top: ${(props) => props.top};
  margin-bottom: ${(props) => props.bottom};
  font-weight: ${(props) => props.weight};
  font-size: ${(props) => props.size};
  display: ${(props) => props.display};
  line-height: ${(props) => props.lh};
  cursor: ${(props) => (props.cursor ? props.cursor : 'pointer')};
`;

export default AppText;
